<p-dialog
  [visible]="visible"
  [closeOnEscape]="false"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '450px' }"
>
  <div *ngIf="isProcessing" class="flex flex-column" style="flex: 1">
    <p-progressBar
      mode="indeterminate"
      [style]="{ height: '6px' }"
    ></p-progressBar>
    <div class="text-center">
      <img
        src="assets/layout/images/ami/processing.svg"
        alt="footer sections"
        width="350"
        height="350"
      />
      <h5 class="text-success">{{ message }}...</h5>
    </div>
  </div>

  <div *ngIf="isResult.information" class="flex flex-column" style="flex: 1">
    <div class="text-center">
      <i class="pi pi-exclamation-circle" style="font-size: 3rem"></i>
      <h4 class="text-success">Información</h4>
      <p-message severity="success" text="{{ message }}"></p-message>
    </div>
  </div>

  <div *ngIf="isResult.success" class="flex flex-column" style="flex: 1">
    <div class="text-center">
      <img
        src="assets/layout/images/ami/success-message.svg"
        alt="footer sections"
        width="380"
        height="380"
      />
      <h5 class="text-success">{{ message }}...</h5>
    </div>
  </div>

  <div *ngIf="isResult.redirection" class="flex flex-column" style="flex: 1">
    <div class="text-center">
      <i class="pi pi-arrow-circle-right" style="font-size: 3rem"></i>
      <h4 class="text-info">Redirección</h4>
      <p-message severity="error" text="{{ message }}"></p-message>
    </div>
  </div>

  <div *ngIf="isResult.clientError" class="flex flex-column" style="flex: 1">
    <div class="text-center">
      <i class="pi pi-user" style="font-size: 3rem"></i>
      <h4 class="text-error">Error Cliente</h4>
      <p-message severity="error" text="{{ message }}"></p-message>
    </div>
  </div>

  <div *ngIf="isResult.serverError" class="flex flex-column" style="flex: 1">
    <div class="text-center">
      <i class="pi pi-times-circle" style="font-size: 3rem"></i>
      <h4 class="text-error">Error Servidor</h4>
      <p-message severity="error" text="{{ message }}"></p-message>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      [disabled]="isProcessing"
      icon="pi pi-arrow-right"
      class="p-button-text"
      label="Cerrar"
      (click)="visible = false"
    ></button>
  </ng-template>
</p-dialog>
